"use strict";
exports.__esModule = true;
var toCamelCase = function (str) {
    return str.toLowerCase().replace(/([-_][a-z])/g, function (group) { return group.toUpperCase().replace('-', '').replace('_', ''); });
};
exports["default"] = toCamelCase;
